// // TODO： 新增的行数据咋办？
// if (默认) {
//   全量加载表头 + 所有子孙
// }
// if (子孙开启分页) {
//   if (首次加载) {
//     只加载开启分页的子孙第一页
//   }
//   if (翻页) {
//     翻页数据累积（分页显示通过filter实现）
//   }
//   if (分页大小变化) {
//     覆盖现有列表数据
//   }
// }
// if (子孙搜索) {
//   if (对应列表未开启分页) {
//     从已加载全量数据中筛选（tableStore + filter）
//   } else {
//     对应子孙全量覆盖
//   }
// }

import { reaction } from 'mobx'
import { detail } from '@api'
import { cloneDeep } from 'lodash'
import { PAGE_INDEX, ROW_KEY } from '@stores/cardstore/constants'

export default function (rootStore: object, cardReactionMeta, param: object) {
  const { filter, paging, alias } = param;
  if (rootStore.pageStore?.bRunInDesigner) return
  const cardStore = rootStore[cardReactionMeta.cardStore]
  paging && subTableConfirm(rootStore, alias, paging)
  const ListOfCardReactions = {
    // 子/孙查询区触发查询
    filterChanged: reaction(
      () => rootStore[filter]?.queryTrigger,
      () => {
        if (cardStore.isAdd) return
        const hasConditions = hasEffectiveConditions(rootStore[filter])
        // 查询条件为空则展示全量数据（未开启分页，store已存储全量数据，移除filter）
        if (
          !hasConditions &&
          !param.paging
        ) {
          const store = rootStore[alias]
          store.removeFilter(store.filters.find(filter => filter.type === 'query'))
          return
        }
        if (paging) {
          const pageStore = rootStore[paging]
          pageStore.setPageInfo({
            pageIndex: 1
          })
          loadPageInfo(rootStore, cardReactionMeta, param)
        }
        loadListData(rootStore, cardReactionMeta, param, false, 1)
      }
    ),
    // 子/孙翻页
    pageIndexChanged: reaction(
      () => rootStore[paging]?.pageIndex,
      (next) => {
        if (cardStore.isAdd) return
        const loadedPages = getLoadedPages(rootStore[cardReactionMeta.cardStore], param)
        const loaded = loadedPages.find(v => v.index == next)
        if (!loaded || loaded?.reload) {
          loadListData(rootStore, cardReactionMeta, param, loaded?.reload == true ? false : true, next)
          if (loaded?.reload) loaded.reload = false
        }
      }),
    // 子/孙分页大小变更
    pageSizeChanged: reaction(
      () => rootStore[paging]?.pageSize,
      (next) => {
        if (cardStore.isAdd) return
        loadListData(rootStore, cardReactionMeta, param, false, 1)
      }
    ),

    pageErrorMessage: reaction(
      () => rootStore[paging]?.errorMessage,
      (messages) => {
        messages?.includes(true) && rootStore.utils.message.danger(cardReactionMeta?.subErrorMessage || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A23243E04580003', '当前页面有未保存信息，请保存后切换!'));
      }
    )

  }
  return ListOfCardReactions;
}

async function subTableConfirm(rootStore, alias, paging) {
  const pagingStore = rootStore?.[paging]
  const tableStore = rootStore?.[alias]
  pagingStore.hooks['checkChange'] = function (pageInfo) {
    return tableStore.hasChangedRows
  }
}

/**
 * 加载list数据
 * @param rootStore
 * @param param
 */
async function loadListData(rootStore: object, cardReactionMeta, param: object, concat = false, pageIndex) {
  const { cardStore: cardStoreAlias } = cardReactionMeta
  const cardStore = rootStore[cardStoreAlias]
  try {
    const params = await cardStore.getQueryParams(param)
    const loadParams = { params: params?.query, data: params?.data };
    const tableStore = rootStore[param.alias]
    rootStore.pageStore?.startLoading?.()
    const res = await detail(loadParams)
    const listData = res?.data?.[param.dataSource] || []
    if (!param.paging) {
      rootStore[param.alias].addFilter({
        type: 'query',
        fn: row => {
          const matchedIDs = listData.map(item => item.id)
          const rowID = row.getValue('id')
          return matchedIDs.includes(rowID)
        }
      })
      return
    }
    if (pageIndex !== undefined) {
      listData.forEach(row => {
        row[PAGE_INDEX] = pageIndex
      })
    }
    const loadedPages = getLoadedPages(cardStore, param)
    if (!concat) {
      loadedPages.length = 0
    }
    loadedPages.push({ index: pageIndex, reload: false })
    cardStore?.setSubValue(param.alias, listData, { concat })
  } catch (err) {
    rootStore.utils.message.danger(err?.message);
    return Promise.reject(err);
  } finally {
    rootStore.pageStore?.endLoading?.()
  }
}

async function loadPageInfo(rootStore: object, cardReactionMeta, param: any) {
  const { cardStore: cardStoreAlias } = cardReactionMeta
  const cardStore = rootStore[cardStoreAlias]
  try {
    const params = await cardStore.getQueryParams(param, true)
    const loadParams = { params: params?.query, data: params?.data };
    const { paging, alias } = param
    rootStore.pageStore?.startLoading?.()
    let pagingInfo = await detail(loadParams)
    pagingInfo = pagingInfo?.data
    cardStore.tableStores.forEach(tabeStoreDescription => {
      const { paging: sPaging, dataSource: sDataSource, alias: sAlias, children } = tabeStoreDescription
      if (sPaging !== paging) return
      const sStore = rootStore[sAlias]
      if (children?.length) {
        children.forEach(grandTableStoreDesctiption => {
          const { alias: gAlias, paging: gPaging, dataSource: gDataSource } = grandTableStoreDesctiption
          const gPagingStore = rootStore[gPaging]
          const gStore = rootStore[gAlias]
          if (gPaging) {
            gPagingStore.sActiveChangeReaction?.()
            gPagingStore.sActiveChangeReaction = reaction(
              () => sStore.currentActiveRow?.getValue(ROW_KEY),
              (sActiveRowKey) => {
                const total = pagingInfo?.[sDataSource]?.[sActiveRowKey]?.[gDataSource]?.totalCount || 0
                gPagingStore.setPageInfo({
                  total
                })
              }
            )
          }
        })
      }
    });
    const pagingStore = rootStore[paging]
    pagingStore.setPageInfo({
      total: pagingInfo?.[param.dataSource]?.totalCount
    })
  } catch (error) {
    rootStore.utils.message.danger(error?.message);
  } finally {
    rootStore.pageStore?.endLoading?.()
  }
}

function hasEffectiveConditions(store) {
  const conditions = store?.getAllCondition?.()
  return conditions?.conditions?.find(condition => !!condition.items?.length)
}

export function getLoadedPages(cardStore, tabeStoreDescription) {
  for (const tableStore of cardStore.tableStores) {
    const { alias: sAlias, children = [] } = tableStore
    if (sAlias === tabeStoreDescription.alias) {
      return cardStore.rootStore[sAlias].loadedPages
    }
    for (const gStore of children) {
      const { alias: gAlias } = gStore
      if (gAlias === tabeStoreDescription.alias) {
        const parentActiveKey = cardStore.rootStore[sAlias].currentActiveRow.getValue(ROW_KEY)
        return cardStore.rootStore[gAlias].loadedPages[parentActiveKey]
      }
    }
  }
}